
import instance from './testing.instance';

export const statisticsPath = (body) => instance.post(`/statistics/`, body);


